import { render, staticRenderFns } from "./GeneratedDocument.vue?vue&type=template&id=05624436&scoped=true&"
import script from "./GeneratedDocument.vue?vue&type=script&lang=js&"
export * from "./GeneratedDocument.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedDocument.vue?vue&type=style&index=0&id=05624436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05624436",
  null
  
)

export default component.exports